<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Galerías de Imágenes</h1>
      </div>
    </div>
    <div class="content__row">
      <gallery-list :filters="filters"></gallery-list>
      <gallery-view :gallery="gallery" v-if="galleryAction === 'view' && gallery"></gallery-view>
      <gallery-edit @new="newGallery" :gallery="gallery" v-if="galleryAction === 'edit'" :key="key"></gallery-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'galleryGroupsView'}">Grupos de Galerías</router-link>
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
          <div class="form__container">
            <label class="form__label form__label--required" for="status_id"> Filtrar por Grupo de Galerías</label>
            <div class="form__select-container">
              <select name="status_id" id="status_id" class="form__select" v-model="group_id" @change="setFilters">
                <option :value="null">Selecciona un grupo</option>
                <option v-for="(group, index) in groups" :key="index" :value="group.id" v-text="group.name"></option>
              </select>
            </div>
          </div>
          <div class="form__container">
          <label class="form__label form__label--required" for="status_id">Filtrar por estatus</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-model="status_id" @change="setFilters">
              <option hidden :value="null">Selecciona un estatus</option>
              <option v-for="(status, index) in gallery_status" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
        </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newGallery" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import galleryList from './list'
import galleryView from './view'
import galleryEdit from './edit'
import Mixins from './mixins'
import {gallery_status} from './mocks'
export default {
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    galleryList,
    galleryView,
    galleryEdit
  },
  data: function () {
    return {
      gallery_status: gallery_status,
      key: 0,
      search: null,
      group_id: null,
      status_id: null,
      filters: undefined,
      galleryAction: null,
      gallery: null
    }
  },
  created: function () {
    this.getGroups()
  },
  mounted: function () {
    this.$on('view',id => {
      this.getGallery(id, 'view')
    })
    this.$on('edit',id => {
      this.getGallery(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = filter + '&search=' + this.search
      }
      if (this.status_id) {
        filter = filter + '&status_id=eq:' + this.status_id
      }
      if (this.group_id) {
        filter = filter + '&group_id=eq:' + this.group_id
      }
      filter = filter.replace(/(^&+|&+$)/, '')
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getGallery: function (id, action) {
      this.galleryAction = action
      let httpRequest = {
        params: '',
        module: 'galleries'
      }
      this.getById(id, httpRequest)
        .then(
          gallery => {
            this.gallery = gallery.data
          }
        )
    },
    newGallery: function () {
      this.gallery = undefined
      this.key = ++this.key
      this.galleryAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/galleries/galleries.vue